export default [
  {
    path: '/main/settings/testar',
    name: 'listsettingstestar',
    meta: {
      tag: 'list_settings_testar',
      name: 'Configurações Testar',
      breadcrumb: 'Configurações Testar'
    },
    component: () => import(/* webpackChunkName: "testar-settings-list" */ '@/views/main/settings/Test.vue')
  },
  {
    path: '/main/settings/arena',
    name: 'listsettingsarena',
    meta: {
      tag: 'list_settings_arena',
      name: 'Configurações Arena',
      breadcrumb: 'Configurações Arena'
    },
    component: () => import(/* webpackChunkName: "arena-settings-list" */ '@/views/main/settings/Arena.vue')
  },
  {
    path: '/main/settings/financial',
    name: 'listsettingsfinancial',
    meta: {
      tag: 'list_settings_financial',
      name: 'Configurações Financeiro',
      breadcrumb: 'Configurações Financeiro'
    },
    component: () => import(/* webpackChunkName: "financial-settings-list" */ '@/views/main/settings/Financial.vue')
  },
  {
    path: '/main/settings/frota',
    name: 'listsettingsfrota',
    meta: {
      tag: 'list_settings_frota',
      name: 'Configurações Frota',
      breadcrumb: 'Configurações Frota'
    },
    component: () => import(/* webpackChunkName: "frota-settings-list" */ '@/views/main/settings/Frota.vue')
  },
  {
    path: '/main/settings/atendimentos',
    name: 'listsettingsatendimentos',
    meta: {
      tag: 'list_settings_atendimentos',
      name: 'Configurações Atendimentos',
      breadcrumb: 'Configurações Atendimentos'
    },
    component: () => import(/* webpackChunkName: "atendimentos-settings-list" */ '@/views/main/settings/Atendimentos.vue')
  },
  {
    path: '/main/settings/integrador',
    name: 'listsettingsintegrador',
    meta: {
      tag: 'list_settings_integrador',
      name: 'Configurações Integrador',
      breadcrumb: 'Configurações Integrador'
    },
    component: () => import(/* webpackChunkName: "integrador-settings-list" */ '@/views/main/settings/Integrador.vue')
  }
]
